export default __webpack_public_path__ + "static/media/LOT_FI.37ef4002.png";